<template>
    <div id="main" ref="cockpit" :class="{ 'no-charts': !showCharts }">
        <div class="page">
            <!-- Barra Superior -->
            <div class="columns chart-toolbar is-multiline z-index-1">
                <!-- COLLAPSE DO FILTRO -->
                <div class="column">
                    <b-collapse class="card" :open="false">
                        <div slot="trigger" slot-scope="props" class="card-header is-paddingless">
                            <div class="card-header-title">
                                <div class="filtro-header">
                                    <b-icon
                                        :icon="props.open ? 'menu-down' : 'menu-right'"
                                    ></b-icon>
                                    <span class="is-size-7">{{ $t('filtros') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="columns is-multiline is-variable is-2">
                                <!-- COMBOS TIPO, VENDEDORES E EMPRESA -->
                                <div
                                    class="column is-full-touch is-full-desktop is-full-widescreen is-two-thirds-fullhd"
                                >
                                    <div class="columns is-variable is-2">
                                        <div class="column">
                                            <label
                                                ><span>{{ $t('tipo-analise') }}</span></label
                                            >
                                            <vss-select
                                                v-model="tipoAnaliseInner"
                                                :options="tipoAnalise"
                                                no-clearfix
                                                ml-labels
                                            />
                                        </div>
                                        <div v-if="empresas.length > 0" class="column">
                                            <label
                                                ><span>{{ $t('empresas') }}</span></label
                                            >
                                            <vss-select
                                                v-model="empresasInner"
                                                label="rsocial"
                                                :options="empresas"
                                                :closeOnSelect="false"
                                                @input="clearSelect($event, 'emrpesas')"
                                                compareId
                                                no-clearfix
                                                multiple
                                                clearable
                                            >
                                                <template #multiple-selected="{ selected }">
                                                    ({{
                                                        selected && selected.length > 0
                                                            ? selected.length
                                                            : $t('todos')
                                                    }})
                                                </template>
                                            </vss-select>
                                        </div>
                                        <div class="column">
                                            <label>
                                                <span>{{ $t('vendedores') }}</span>
                                                <b-icon
                                                    icon="information"
                                                    size="is-small"
                                                    v-tippy
                                                    :title="$t('msg-filtros-vendedores')"
                                                />
                                            </label>
                                            <vss-select
                                                v-model="vendedoresInner"
                                                label="nome"
                                                :options="vendedores"
                                                :closeOnSelect="false"
                                                :loading="vendedoresLoading"
                                                @search="loadVendedores"
                                                @input="clearSelect($event, 'vendedores')"
                                                no-clearfix
                                                multiple
                                                clearable
                                                searchable
                                                compareId
                                            >
                                                <template #multiple-selected="{ selected }">
                                                    ({{
                                                        selected && selected.length > 0
                                                            ? selected.length
                                                            : $t('todos')
                                                    }})
                                                </template>
                                            </vss-select>
                                        </div>
                                        <div class="column">
                                            <vss-select
                                                title="tipo-pedido"
                                                placeholder="selecione"
                                                :options="tipoPedidoList"
                                                v-model="tipoPedidoSelected"
                                                :loading="tipoPedidoLoading"
                                                @search="carregarTipoPedido"
                                                @input="clearSelect($event, 'tiposPedido')"
                                                multiple
                                                searchable
                                                clearable
                                                no-clearfix
                                                :closeOnSelect="false"
                                            >
                                                <template #multiple-selected="{ selected }">
                                                    ({{
                                                        selected && selected.length > 0
                                                            ? selected.length
                                                            : $t('todos')
                                                    }})
                                                </template>
                                            </vss-select>
                                        </div>
                                    </div>
                                </div>

                                <!-- DATAS -->
                                <div
                                    class="column is-full-touch is-full-desktop is-full-widescreen is-one-third-fullhd"
                                >
                                    <div class="columns is-variable is-2">
                                        <div class="column">
                                            <verified-date-picker
                                                dateType="startDate"
                                                v-model="datainicio"
                                                :endDate="datafim"
                                                :title="'data-inicio'"
                                                position="is-bottom-right"
                                                :invalid="erroDataInicio"
                                                :tooltipLabel="'informacao-filtro-data-inicial-cockpit'"
                                                tooltipSize="is-medium"
                                                tooltipPosition="is-bottom"
                                            />
                                        </div>
                                        <div class="column">
                                            <verified-date-picker
                                                dateType="endDate"
                                                v-model="datafim"
                                                :startDate="datainicio"
                                                :title="'data-fim'"
                                                position="is-bottom-left"
                                                :invalid="erroDataFim"
                                                :addDateYears="5"
                                                :tooltipLabel="'informacao-filtro-data-fim-cockpit'"
                                                tooltipSize="is-medium"
                                                tooltipPosition="is-bottom"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>

                <!-- BOTÕES -->
                <div class="column is-narrow">
                    <b-button
                        class="top-btn"
                        type="is-light"
                        @click="saveFiltros"
                        :disabled="isSavingFilter"
                    >
                        <span class="has-text-weight-bold is-size-7">
                            {{ $t('aplicar-filtros') }}
                        </span>
                    </b-button>

                    <b-button
                        class="top-btn"
                        type="is-light"
                        @click="confirmCleanFilters"
                        :disabled="isSavingFilter"
                    >
                        <span class="has-text-weight-bold is-size-7">
                            {{ $t('limpar-filtros') }}
                        </span>
                    </b-button>

                    <b-button
                        class="top-btn"
                        icon-left="settings"
                        type="is-primary"
                        @click="openModalGraficos"
                        :disabled="isSavingFilter"
                    >
                        <span class="has-text-weight-bold is-size-7">
                            {{ $t('gerenciar-graficos') }}
                        </span>
                    </b-button>
                </div>
            </div>

            <div
                class="evo-card mr-3 pt-1"
                v-if="showCharts && chartDataset.some((e) => e.tipo == 'evolucao-vendas')"
            >
                <EvolucaoVendas
                    :inicio="
                        $moment(
                            (filtroList.find((e) => e.tipo == 'data-inicio') || {}).valor
                        ).format('YYYY-MM-DD')
                    "
                    :fim="
                        $moment((filtroList.find((e) => e.tipo == 'data-fim') || {}).valor).format(
                            'YYYY-MM-DD'
                        )
                    "
                    :filtros="filtroList"
                    :vendedores-combo="vendedoresResultadoAtual"
                    :tiposPedido="tipoPedidoSelected"
                    @update-content="
                        updateChart(
                            $event,
                            chartDataset.findIndex((e) => e.tipo == 'evolucao-vendas')
                        )
                    "
                />
            </div>

            <!-- Gráficos -->
            <div class="chart-container mt-4 mr-3" ref="PackeryMagic" v-if="showCharts">
                <div class="pkry-gutter"></div>
                <div class="pkry-sizer"></div>
                <div
                    v-for="(d, i) in chartDataset"
                    :key="i"
                    class="chart"
                    ref="chartItem"
                    :class="{
                        'full-size-chart':
                            d && d.titulo == 'chart-colaborador-visita-periodo-do-dia-vendas',
                        'big-number': d && d.tipo == 'bignumber',
                        speedometer: d && d.tipo == 'speedometer',
                        'line-chart': lineChartClas(d),
                        'is-invisible': d && d.tipo == 'evolucao-vendas',
                    }"
                    :data-title="d.titulo"
                    :data-item-id="i"
                >
                    <BigNumber
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'bignumber'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :filtro="filtros"
                        :info="showInfo(d.titulo)"
                        module="VENDAS"
                        @update-content="updateChart($event, i)"
                        :tituloGrafico="`${d.titulo}`"
                    />
                    <ZoomBarChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'zoombar'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :direction="d.direction"
                        :info="showInfo(d.titulo)"
                        :filtro="filtros"
                        module="VENDAS"
                        @update-content="updateChart($event, i)"
                    />
                    <GroupBarChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'bar'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :direction="d.direction"
                        :filtro="filtros"
                        :info="showInfo(d.titulo)"
                        module="VENDAS"
                        @update-content="updateChart($event, i)"
                    />
                    <DonutChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'donut'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :filtro="filtros"
                        :info="showInfo(d.titulo)"
                        module="VENDAS"
                        @update-content="updateChart($event, i)"
                    />
                    <FunnelChart
                        :ref="`${d.tipo}-${d.titulo}`"
                        v-if="d && d.tipo == 'funnel'"
                        :title="$t(d.titulo)"
                        :datacontent="d"
                        :filtro="filtros"
                        :info="showInfo(d.titulo)"
                        module="VENDAS"
                        @update-content="updateChart($event, i)"
                    />
                </div>
            </div>

            <!-- Página não há dados -->
            <section class="hero is-fullheight" v-else-if="!isLoading">
                <div class="hero-body">
                    <div class="container has-text-centered">
                        <div class="elipse">
                            <svg class="big-svg-icons">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/speedometer.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                        </div>
                        <p style="margin-top: 10px">
                            {{ $t('cockpit-sem-dados-vendas') }}
                        </p>
                        <button
                            class="button no-data-btn"
                            type="button"
                            @click="openModalGraficos"
                            style="margin-top: 10px"
                        >
                            {{ $t('gerenciar-graficos') }}
                        </button>
                    </div>
                </div>
            </section>

            <!-- Modal de gerenciar gráficos -->
            <b-modal :active.sync="isChartSelectOpen">
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="title is-marginless is-paddingless">
                            {{ $t('add-graficos-cockpit') }}
                            <b-icon
                                v-if="!permissao.create || !permissao.update"
                                icon="information"
                                size="is-small"
                                v-tippy
                                :title="$t('sem-permissao-para-todas-as-acoes')"
                            />
                        </p>
                    </header>
                    <section
                        class="modal-card-body"
                        v-if="chartsAvailable && chartsAvailable.length > 0"
                    >
                        <div class="columns">
                            <div class="column">
                                <search-bar :onSearch="debouncedOnSearch" hideTitle />
                            </div>
                        </div>
                        <div class="columns is-mobile">
                            <div class="categorias column is-one-third">
                                <div class="columns is-multiline">
                                    <div class="column is-full">
                                        <span class="subtitle">{{ $t('categorias') }}</span>
                                    </div>
                                    <div
                                        class="column is-full"
                                        v-for="(c, i) in categorias"
                                        :key="i"
                                    >
                                        <a @click="filterCategoria(c.nome)">{{ $t(c.nome) }}</a>
                                        <span class="tag is-pulled-right">{{ c.qtd }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="result-set column">
                                <div class="columns is-multiline">
                                    <div
                                        class="column is-full"
                                        v-for="(c, i) in resultSet"
                                        :key="i"
                                    >
                                        <span class="subtitle has-text-justified">{{
                                            $t(c.nome)
                                        }}</span>
                                        <p class="has-text-justified" style="font-size: 12px">
                                            {{ getChartDesc(c) }}
                                        </p>
                                        <button
                                            v-if="isInCockpit(c) && permissao.delete"
                                            class="delete-btn"
                                            :class="c.isSaving ? 'disabled' : ''"
                                            @click="deleteChart(c)"
                                            :disabled="c.isSaving"
                                        >
                                            {{ $t('del-cockpit') }}
                                            <button-loader :isSaving="c.isSaving" />
                                        </button>
                                        <button
                                            v-else-if="permissao.create && !isInCockpit(c)"
                                            class="add-btn"
                                            :class="c.isSaving ? 'disabled' : ''"
                                            @click="addChart(c)"
                                            :disabled="c.isSaving"
                                        >
                                            {{ $t('add-cockpit') }}
                                            <button-loader :isSaving="c.isSaving" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section v-else>
                        <div class="columns">
                            <div class="no-results column">
                                {{ $t('sem-graficos') }}
                            </div>
                        </div>
                    </section>
                </div>
            </b-modal>
        </div>
        <br style="clear: both" /><br />
    </div>
</template>

<script>
import CockpitVendasService from '@/services/CockpitVendasService';
import CockpitAgroService from '@/services/agro/cockpit/CockpitAgroService';
import GroupBarChart from '@/components/shared/chart/GroupBarChart';
import HelperCard from '@/components/shared/HelperCard';
import DonutChart from '@/components/shared/chart/DonutChart';
import PieChart from '@/components/shared/chart/PieChart';
import AreaChart from '@/components/shared/chart/AreaChart';
import LineChart from '@/components/shared/chart/LineChart';
import BigNumber from '@/components/shared/chart/BigNumber';
import ZoomBarChart from '@/components/shared/chart/ZoomBarChart';
import BarChart from '@/components/shared/chart/BarChart';
import StackBarChart from '@/components/shared/chart/StackBarChart';
import SpeedometerChart from '@/components/shared/chart/SpeedometerChart';
import EvolucaoVendas from './EvolucaoVendas';
import FunnelChart from '@/components/shared/chart/FunnelChart';
import FiltroCockpitService from '@/services/FiltroCockpitService';
import TipoPedidoService from '@/services/vendas/TipoPedidoService.js';
import $ from 'jquery';
import * as Draggable from 'jquery-ui/ui/widgets/draggable.js';
import Packery from 'packery';
import GerenciarUsuariosService from '@/services/conta/GerenciarUsuariosService';

export default {
    components: {
        HelperCard,
        DonutChart,
        PieChart,
        LineChart,
        AreaChart,
        ZoomBarChart,
        BarChart,
        BigNumber,
        SpeedometerChart,
        StackBarChart,
        EvolucaoVendas,
        GroupBarChart,
        FunnelChart,
    },
    data() {
        return {
            day_names: [
                this.$t('dom'),
                this.$t('seg'),
                this.$t('ter'),
                this.$t('qua'),
                this.$t('qui'),
                this.$t('sex'),
                this.$t('sab'),
            ],
            month_names: [
                this.$t('january'),
                this.$t('february'),
                this.$t('march'),
                this.$t('april'),
                this.$t('may'),
                this.$t('june'),
                this.$t('july'),
                this.$t('august'),
                this.$t('september'),
                this.$t('october'),
                this.$t('november'),
                this.$t('december'),
            ],
            jqi: $,
            service: null,
            filtroCockpitService: new FiltroCockpitService(this.$http, this.$router),
            colaboradorService: new GerenciarUsuariosService(this.$http, this.$router),
            agroService: new CockpitAgroService(this.$http, this.$router),
            tipoPedidoService: new TipoPedidoService(this.$http, this.$router),
            chartDataset: [],
            lastSize: { w: 0, h: 0 },
            isLoading: false,
            isChartSelectOpen: false,
            chartsAvailable: [],
            categorias: [],
            searchSet: [],
            resultSet: [],
            searching: false,
            fvwChartList: [],
            pckr: null,
            newCharts: [],
            layout: {
                tipo: 'vendas',
                grande: { tipo: 'vendas' },
                medio: { tipo: 'vendas' },
                pequeno: { tipo: 'vendas' },
            },
            dragOpts: {
                zIndex: 100,
                handle: '.chart-title',
                containment: '.chart-container',
            },
            firstReload: false,
            curScreenSize: 1201,
            prevScreenSize: 1201,
            loadedPositions: false,
            packeryOpts: {
                itemSelector: '.chart',
                percentPosition: true,
                shiftPercentResize: true,
                transitionDuration: '0.3s',
                gutter: '.pkry-gutter',
                columnWidth: '.pkry-sizer',
            },
            isSavingFilter: false,
            showVendedores: false,
            tipoPedidoList: [],
            tipoPedidoSelected: [],
            tipoPedidoLoading: false,
            vendedores: [],
            vendedoresInner: [],
            vendedoresLoading: false,
            empresas: [],
            empresasInner: [],
            filtroList: [],
            filtros: {
                empresas: [],
                filtraEmpresa: false,
                vendedores: [],
                tiposPedido: [],
                tipoAnalise: 'pedido',
                /*  Para as datas, seta o valor inicial, se vier algo diferente do banco
                    eles serão sobreescritos após carregar os filtros. */
                datainicio: null,
                datafim: null,
            },
            tipoAnalise: ['pedido', 'faturamento'],
            tipoAnaliseInner: 'pedido',
            vendedoresResultadoAtual: [],
            datainicio: new Date(this.$moment().subtract(30, 'days')),
            datafim: new Date(),
            staticDataInicial: undefined,
            staticDataFinal: undefined,
            showCharts: false,
            permissao: {},
            erroDataInicio: false,
            erroDataFim: false,
        };
    },
    created() {
        this.saveChartPositions();

        this.permissao = this.hasPermissionAccess('vendas', 'cockpit', 'ven-cockpit');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'vendas-titulo-cockpit' },
            });
        }

        if (this.permissao.read) {
            this.staticDataInicial = this.datainicio;
            this.staticDataFinal = this.datafim;
            this.filtros.datainicio = this.datainicio;
            this.filtros.datafim = this.datafim;

            this.isLoading = true;
            this.service = new CockpitVendasService(this.$http, this.$router);

            this.startVendedores();
            this.fetchEmpresas();
            this.carregarCartoes();

            let body = document.getElementsByTagName('body')[0];
            this.curScreenSize = window.innerWidth;
            this.prevScreenSize = window.innerWidth;

            this.lastSize.w = document.body.clientWidth;
            this.lastSize.h = document.body.clientHeight;

            body.onresize = this.debounce(this.resize, 150);
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.debouncedRedraw = this.debounce(this.redrawCharts, 1000);

            setTimeout(() => {
                this.saveChartPositions();
            }, 2000);

            this.getChartsAvaleble();
        }
    },
    beforeDestroy() {
        this.mapToSaveChart();
    },
    methods: {
        getChartsAvaleble() {
            this.chartsAvailable = [
                {
                    nome: 'chart-cliente-por-vendedor-12-meses',
                    categoria: 'clientes',
                    descricao: 'chart-cliente-por-vendedor-12-meses-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-clientes-por-status-comercial-barra',
                    categoria: 'clientes',
                    descricao: 'chart-clientes-por-status-comercial-barra-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-titulos-vencidos',
                    categoria: 'titulos',
                    descricao: 'chart-titulos-vencidos-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-titulos-a-vencer',
                    categoria: 'titulos',
                    descricao: 'chart-titulos-a-vencer-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-titulos-por-data',
                    categoria: 'titulos',
                    descricao: 'chart-titulos-por-data-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-clientes-por-atividade',
                    categoria: 'clientes',
                    descricao: 'chart-clientes-por-atividade-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-clientes-por-status-comercial',
                    categoria: 'clientes',
                    descricao: 'chart-clientes-por-status-comercial-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-cliente-com-vendas',
                    categoria: 'clientes',
                    descricao: 'chart-cliente-com-vendas-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-vendas-por-periodo',
                    categoria: 'vendas',
                    descricao: 'chart-vendas-por-periodo-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-rotas-cadastradas',
                    categoria: 'routes',
                    descricao: 'chart-rotas-cadastradas-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-cliente-sem-vendas-por-vendedor',
                    categoria: 'clientes',
                    descricao: 'chart-cliente-sem-vendas-por-vendedor-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-cliente-por-vendedor',
                    categoria: 'clientes',
                    descricao: 'chart-cliente-por-vendedor-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-cliente-por-faturamento-abc',
                    categoria: 'clientes',
                    descricao: 'chart-cliente-por-faturamento-abc-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-clientes-novos',
                    categoria: 'clientes',
                    descricao: 'chart-clientes-novos-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-motivonaovenda',
                    categoria: 'vendas',
                    descricao: 'chart-motivonaovenda-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-clientes-regiao',
                    categoria: 'clientes',
                    descricao: 'chart-clientes-regiao-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-clientes-nao-rota',
                    categoria: 'clientes',
                    descricao: 'chart-clientes-nao-rota-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-nao-vendas',
                    categoria: 'vendas',
                    descricao: 'chart-nao-vendas-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-qtd-produtos',
                    categoria: 'produtos',
                    descricao: 'chart-qtd-produtos-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-valor-vendido-por-similar-agreagado',
                    categoria: 'vendas',
                    descricao: 'chart-valor-vendido-por-similar-agreagado-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-evolucao-vendas',
                    categoria: 'vendas',
                    descricao: 'chart-evolucao-vendas-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-visitas-colaborador-vendas',
                    categoria: 'atendimentos',
                    descricao: 'chart-visitas-colaborador-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-visitas-empresa-vendas',
                    categoria: 'atendimentos',
                    descricao: 'chart-visitas-empresa-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-colaborador-visita-periodo-do-dia-vendas',
                    categoria: 'atendimentos',
                    descricao: 'chart-colaborador-visita-periodo-do-dia-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-clientes-atendimentos',
                    categoria: 'atendimentos',
                    descricao: 'chart-clientes-atendimentos-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-venda-atendimentos',
                    categoria: 'atendimentos',
                    descricao: 'chart-venda-atendimentos-descricao',
                    isSaving: false,
                },
                {
                    nome: 'chart-cliente-cidade',
                    categoria: 'clientes',
                    descricao: 'chart-cliente-cidade-descricao',
                    isSaving: false,
                },
            ];
        },
        clearInputs() {
            this.empresasInner = [];
            this.vendedoresInner = [];
            this.tipoPedidoSelected = [];
            this.filtros.empresas = this.empresas.map((e) => e.id);
            this.filtros.filtraEmpresa = false;
            this.filtros.vendedores = this.vendedores.map((e) => e.id);
            this.filtros.tiposPedido = this.tipoPedidoList.map((e) => e.id);
            this.filtros.datainicio = this.staticDataInicial;
            this.datainicio = this.staticDataInicial;
            this.filtros.datafim = this.staticDataFinal;
            this.datafim = this.staticDataFinal;
            this.existeFiltrosSelecionado = false;
        },
        clearSelect(value, select) {
            if (value.length == 0) {
                if (select == 'empresas') {
                    this.empresasInner = [];
                    this.filtros.empresas = this.empresas.map((e) => e.idempresa);
                    this.filtros.filtraEmpresa = false;
                } else if (select == 'vendedores') {
                    this.vendedoresInner = [];
                    this.filtros.vendedores = this.vendedores.map((e) => e.idusuario);
                } else if (select == 'tiposPedido') {
                    this.tipoPedidoSelected = [];
                    this.filtros.tiposPedido = this.tipoPedidoList.map((e) => e.id);
                }
            }
        },
        confirmCleanFilters() {
            if (this.possuiFiltroSelecionado()) {
                this.$root.confirm({
                    message: this.$t('msg-confirm-limpar-filtros'),
                    onConfirm: this.clearFilters,
                });
            } else {
                this.clearInputs();
            }
        },
        possuiFiltroSelecionado() {
            return this.filtros.tipoAnalise != this.tipoAnalise[0] ||
                this.filtros.empresas.length < this.empresas.length ||
                this.filtros.vendedores.length < this.vendedores.length ||
                this.filtros.tiposPedido.length < this.tipoPedidoList.length ||
                this.filtros.datainicio !== this.staticDataInicial ||
                this.filtros.datafim !== this.staticDataFinal
                ? true
                : false;
        },
        clearFilters() {
            this.tipoAnaliseInner = this.tipoAnalise[0];
            this.empresasInner = [];
            this.vendedoresInner = [];
            this.tipoPedidoSelected = [];
            this.filtros.tipoAnalise = this.tipoAnalise.map((e) => e.id);
            this.filtros.empresas = this.empresas.map((e) => e.idempresa);
            this.filtros.filtraEmpresa = false;
            this.filtros.vendedores = this.vendedores.map((e) => e.idusuario);
            this.filtros.tiposPedido = this.tipoPedidoList.map((e) => e.id);
            this.filtros.datainicio = this.staticDataInicial;
            this.datainicio = this.staticDataInicial;
            this.filtros.datafim = this.staticDataFinal;
            this.datafim = this.staticDataFinal;
            this.existeFiltrosSelecionado = false;
            this.saveFiltros();
        },
        // Para verificar os vendedores pela primeira vez e verificar se precisa mostrar o combo ou não
        startVendedores() {
            this.$store.commit('addLoader');

            this.colaboradorService
                .findAllComboSituacao(1, '')
                .then((r) => {
                    this.showVendedores = r.content && r.content.length > 0;
                    this.vendedores = r.content.map((m) => {
                        return {
                            id: m.idusuario,
                            idusuario: m.idusuario,
                            nome: m.nome,
                            situacao: m.situacao,
                        };
                    });
                    this.filtros.vendedores = this.vendedores.map((e) => e.idusuario);
                })
                .catch((e) => {
                    console.error('Erro ao carregar vendedores.', e);
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                });
        },
        loadVendedores(q) {
            this.vendedoresLoading = true;
            q = this.isNull(q) ? '' : this.removeToSearch(q);

            this.colaboradorService
                .findAllComboSituacao(1, q)
                .then((r) => {
                    this.vendedores = r.content.map((m) => {
                        return {
                            id: m.idusuario,
                            idusuario: m.idusuario,
                            nome: m.nome,
                            situacao: m.situacao,
                        };
                    });
                })
                .catch((e) => {
                    console.error('Erro ao carregar vendedores.', e);
                })
                .finally((_) => {
                    this.vendedoresLoading = false;
                });
        },
        fetchEmpresas() {
            this.empresas = (this.$store.state.user.empresas || []).map((empresa) => ({
                idempresa: empresa.idempresa,
                idempresaerp: empresa.idempresaerp,
                nome: empresa.nome,
                rsocial: empresa.rsocial,
                valordecimalplaces: empresa.valordecimalplaces,
                qtdedecimalplaces: empresa.qtdedecimalplaces,
                id: empresa.idempresa,
            }));
            this.filtros.empresas = this.empresas.map((e) => e.idempresa);
            this.filtros.filtraEmpresa = false;
        },
        resize() {
            let currentSize = {
                w: document.body.clientWidth,
                h: document.body.clientHeight,
            };
            this.curScreenSize = window.innerWidth;

            if (currentSize.w != this.lastSize.w) {
                this.redrawCharts();
            }

            this.lastSize = currentSize;
        },
        redrawCharts() {
            this.$d3.selectAll('.chart-tooltip').remove();
            this.fvwChartList.forEach((c) => {
                let component = this.$refs[`${c.tipo}-${c.titulo}`];
                if (component && component[0]) {
                    component[0].redrawChart();
                }
            });
            this.mountCockpitCharts();
        },
        closeAllFilters() {
            this.fvwChartList.forEach((c) => {
                let component = this.$refs[`${c.tipo}-${c.titulo}`];
                if (component && component[0]) {
                    let el = component[0].$refs;
                    if (el.chartFilter != undefined) {
                        el.chartFilter.popoverShow = false;
                    }
                }
            });
        },
        carregarCartoes() {
            this.$store.commit('addLoader');
            this.filtroCockpitService
                .buscarGraficosComFiltros('vendas')
                .then((res) => {
                    this.filtroList = res.content.filtros;
                    this.getFiltroObject();
                    if (this.vendedoresInner.length > 0) {
                        this.vendedoresResultadoAtual = [...this.vendedoresInner];
                    } else {
                        this.vendedoresResultadoAtual = [...this.vendedores];
                    }
                    this.fvwChartList = res.content.charts;
                    this.loadAll();
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-cockpit');
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                });
        },
        /*  Transformar a list do filtroList para o objeto de filtros. */
        getFiltroObject() {
            this.filtroList.forEach((f) => {
                switch (f.tipo) {
                    case 'tipo-analise':
                        this.tipoAnaliseInner = f.valor;
                        this.filtros.tipoAnalise = f.valor;
                        this.filtros.idfiltrotipoanalise = f.idfiltro;
                        break;
                    case 'empresa':
                        if (f.itens.length > 0)
                            this.filtros.empresas = f.itens.map((e) => e.idempresa);
                        this.empresasInner = f.itens;
                        this.filtros.idfiltroempresa = f.idfiltro;
                        break;
                    case 'vendedor':
                        if (f.itens.length > 0)
                            this.filtros.vendedores = f.itens.map((e) => e.idusuario);
                        this.vendedoresInner = f.itens;
                        this.filtros.idfiltrovendedor = f.idfiltro;
                        break;
                    case 'tipo-pedido':
                        if (f.itens.length > 0) this.filtros.tiposPedido = f.itens.map((e) => e.id);
                        this.tipoPedidoSelected = f.itens.map((m) => ({
                            id: m.id,
                            label: m.descricao,
                        }));
                        this.filtros.idfiltrotipopedido = f.idfiltro;
                        break;
                    case 'data-inicio':
                        this.filtros.datainicio = f.valor;
                        this.datainicio = new Date(f.valor);
                        this.filtros.idfiltrodatainicio = f.idfiltro;
                        break;
                    case 'data-fim':
                        this.filtros.datafim = f.valor;
                        this.datafim = new Date(f.valor);
                        this.filtros.idfiltrodatafim = f.idfiltro;
                        break;
                }
            });
        },

        getFiltroList() {
            this.filtros.tipoAnalise = this.tipoAnaliseInner;
            let filtros = [];

            filtros.push({
                idfiltro: this.filtros.idfiltroempresa,
                tipo: 'empresa',
                multi: true,
                itens: this.empresasInner.map((e) => Number(e.idempresa)),
            });
            if (this.showVendedores) {
                filtros.push({
                    idfiltro: this.filtros.idfiltrovendedor,
                    tipo: 'vendedor',
                    multi: true,
                    itens: this.vendedoresInner.map((e) => Number(e.idusuario)),
                });
            }
            filtros.push({
                idfiltro: this.filtros.idfiltrotipopedido,
                tipo: 'tipo-pedido',
                multi: true,
                itens: this.tipoPedidoSelected.map((e) => Number(e.id)),
            });
            filtros.push({
                idfiltro: this.filtros.idfiltrotipoanalise,
                tipo: 'tipo-analise',
                multi: false,
                valor: this.filtros.tipoAnalise,
            });
            filtros.push({
                idfiltro: this.filtros.idfiltrodatainicio,
                tipo: 'data-inicio',
                multi: false,
                valor: this.filtros.datainicio,
            });
            filtros.push({
                idfiltro: this.filtros.idfiltrodatafim,
                tipo: 'data-fim',
                multi: false,
                valor: this.filtros.datafim,
            });
            return filtros;
        },
        loadAll() {
            let body = document.getElementsByTagName('body')[0];
            this.chartDataset = [...this.fvwChartList];
            // this.mapStackChart();
            if (body.offsetWidth > 760 && body.offsetWidth < 861) {
                let line = this.chartDataset.filter((d) => d.tipo == 'line')[0];
                let i = this.chartDataset.indexOf(line);
                if (i > -1) {
                    this.chartDataset.splice(this.chartDataset.indexOf(line), 1);
                    this.chartDataset.push(line);
                }
            }
            // Mostrar os charts
            this.showCharts = this.chartDataset.length > 0;

            this.mountCockpitCharts();
        },
        carregarTipoPedido(query = null) {
            this.tipoPedidoLoading = true;
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);

            this.tipoPedidoService
                .findAllCombo(query)
                .then(this.mapTipoPedidoList)
                .then((value) => {
                    if (value != null) {
                        this.tipoPedidoList = value;
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load', true);
                })
                .finally((_) => {
                    this.tipoPedidoLoading = false;
                });
        },
        mapTipoPedidoList(response) {
            return response.content.map((m) => {
                return {
                    id: m.id,
                    label: m.descricao,
                };
            });
        },
        mapToSaveChart() {
            if (this.layout.grande) {
                if (typeof this.layout.grande.datacontent != 'string') {
                    this.layout.grande.datacontent = JSON.stringify(this.layout.grande.datacontent);
                }
                this.layout.grande.tamanho = 'grande';
            }
            if (this.layout.medio) {
                if (typeof this.layout.medio.datacontent != 'string') {
                    this.layout.medio.datacontent = JSON.stringify(this.layout.medio.datacontent);
                }
                this.layout.medio.tamanho = 'medio';
            }
            if (this.layout.pequeno) {
                if (typeof this.layout.pequeno.datacontent != 'string') {
                    this.layout.pequeno.datacontent = JSON.stringify(
                        this.layout.pequeno.datacontent
                    );
                }
                this.layout.pequeno.tamanho = 'pequeno';
            }
            // Estava no BeforeDestroy
            this.service.saveChartLayout(this.layout);
            document.body.onresize = null;
        },
        mountCockpitCharts() {
            setTimeout(() => {
                if (this.$refs.chartItem && this.$refs.chartItem.length > 0) {
                    if (this.pckr != null) this.pckr.destroy();
                    let elemPack = this.$refs.PackeryMagic;
                    if (this.loadedPositions) {
                        setTimeout(() => {
                            this.getChartPositions(elemPack, this.layout);
                        }, 1000);
                    } else {
                        this.$store.commit('addLoader');
                        this.service
                            .getChartLayout(this.layout.tipo)
                            .then((l) => {
                                if (l) {
                                    this.layout = l;
                                }
                                var initPositions = this.layout;
                                if (initPositions) {
                                    this.packeryOpts.layout = false;
                                }
                                setTimeout(() => {
                                    this.getChartPositions(elemPack, initPositions);
                                }, 1000);
                                this.loadedPositions = true;
                            })
                            .finally((_) => {
                                this.$store.commit('removeLoader');
                            });
                    }
                } else {
                    if (this.pckr != null) {
                        this.pckr.destroy();
                        this.pckr = null;
                    }
                }
                setTimeout(() => {
                    this.addNewChartPosition();
                }, 200);
            }, 100);
        },
        // Métodos do gerenciamento de gráficos
        filterCategoria(nome) {
            if (this.searching) {
                this.resultSet = this.searchSet.filter((c) => {
                    return c.categoria == nome;
                });
            } else {
                this.resultSet = this.chartsAvailable.filter((c) => {
                    return c.categoria == nome;
                });
            }
        },
        isInCockpit(c) {
            return this.chartDataset.find((e) => {
                return e.titulo == c.nome;
            });
        },
        getCategories() {
            // Usado dentro de gerenciar gŕaficos
            this.categorias = [];
            this.resultSet.forEach((c) => {
                var index = this.categorias.findIndex((e) => {
                    return e.nome == c.categoria;
                });
                if (index < 0) {
                    this.categorias.push({
                        nome: c.categoria,
                        qtd: 1,
                    });
                } else {
                    this.categorias[index].qtd++;
                }
            });
        },
        getChartPositions(elemPack, initPositions) {
            this.pckr = new Packery(elemPack, this.packeryOpts);
            this.pckr.on('dragItemPositioned', (abc) => {
                this.firstReload = true;
                var positions = this.pckr.getShiftPositions('data-item-id');
                if (this.curScreenSize > 1200) {
                    if (this.layout.grande) {
                        this.layout.grande.datacontent = positions;
                        this.layout.grande.tipo = 'vendas';
                    } else {
                        this.layout.grande = { datacontent: positions, tipo: 'vendas' };
                    }
                } else if (this.curScreenSize < 760) {
                    if (this.layout.pequeno) {
                        this.layout.pequeno.datacontent = positions;
                        this.layout.pequeno.tipo = 'vendas';
                    } else {
                        this.layout.pequeno = { datacontent: positions, tipo: 'vendas' };
                    }
                } else {
                    if (this.layout.medio) {
                        this.layout.medio.datacontent = positions;
                        this.layout.medio.tipo = 'vendas';
                    } else {
                        this.layout.medio = { datacontent: positions, tipo: 'vendas' };
                    }
                }

                this.mapToSaveChart();
            });

            this.$refs.chartItem.forEach((c) => {
                c.draggable = new Draggable(this.dragOpts, c);
                this.bindDraggables(c);
            });

            let layout = null;
            if (initPositions) {
                if (this.curScreenSize > 1200) {
                    if (initPositions.grande) {
                        if (initPositions.grande.datacontent != '') {
                            if (typeof initPositions.grande.datacontent === 'string') {
                                layout = JSON.parse(initPositions.grande.datacontent);
                            }

                            if (layout != null && layout.length == this.chartDataset.length) {
                                this.pckr.initShiftLayout(
                                    initPositions.grande.datacontent,
                                    'data-item-id'
                                );
                            } else {
                                this.pckr.shiftLayout();
                            }
                        } else {
                            this.pckr.shiftLayout();
                        }
                    } else {
                        this.pckr.shiftLayout();
                    }
                } else if (this.curScreenSize < 760) {
                    if (initPositions.pequeno) {
                        if (initPositions.pequeno.datacontent != '') {
                            if (typeof initPositions.pequeno.datacontent === 'string') {
                                layout = JSON.parse(initPositions.pequeno.datacontent);
                            }

                            if (layout != null && layout.length == this.chartDataset.length) {
                                this.pckr.initShiftLayout(
                                    initPositions.pequeno.datacontent,
                                    'data-item-id'
                                );
                            } else {
                                this.pckr.shiftLayout();
                            }
                        } else {
                            this.pckr.shiftLayout();
                        }
                    } else {
                        this.pckr.shiftLayout();
                    }
                } else {
                    if (initPositions.medio) {
                        if (initPositions.medio.datacontent != '') {
                            if (typeof initPositions.medio.datacontent === 'string') {
                                layout = JSON.parse(initPositions.medio.datacontent);
                            }

                            if (layout != null && layout.length == this.chartDataset.length) {
                                this.pckr.initShiftLayout(
                                    initPositions.medio.datacontent,
                                    'data-item-id'
                                );
                            } else {
                                this.pckr.shiftLayout();
                            }
                        } else {
                            this.pckr.shiftLayout();
                        }
                    } else {
                        this.pckr.shiftLayout();
                    }
                }
            }
        },
        onSearch(value) {
            var searchValue = value.trim();
            if (searchValue != '') {
                this.searching = true;
                this.resultSet = this.chartsAvailable.filter((c) => {
                    return this.$t(c.nome).search(new RegExp(searchValue, 'i')) > -1;
                });
                this.searchSet = this.resultSet;
            } else {
                this.searching = false;
                this.resultSet = this.chartsAvailable;
            }
            this.getCategories();
        },
        deleteChart(c) {
            // c => resultSet
            c.isSaving = true;
            let chartIndex = this.fvwChartList.findIndex((e) => e.titulo == c.nome);
            if (chartIndex !== -1) {
            let chart = this.fvwChartList[chartIndex];
            this.service.delete(chart.id).then((res) => {
                if (res) {
                    let datasetIndex = this.chartDataset.findIndex((e) => e.titulo == c.nome);
                    if (datasetIndex !== -1) {
                        this.chartDataset.splice(datasetIndex, 1);
                    }
                    this.fvwChartList.splice(chartIndex, 1);
                    c.isSaving = false;
                    this.debouncedRedraw();

                    // Save chart positions every time a chart is removed.
                    this.saveChartPositions();
                    this.mapToSaveChart();
                }
            });
            }
        },
        addChart(c) {
            c.isSaving = true;
            this.firstReload = true;
            this.getFiltroObject();
            switch (c.nome) {
                case 'chart-cliente-por-vendedor-12-meses':
                    this.service
                        .getClientesPorVendedor(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-clientes-por-status-comercial-barra':
                    this.service
                        .getClientesPorStatusComercialBarra(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-titulos-vencidos':
                    this.service
                        .getTitulosVencidos(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-titulos-a-vencer':
                    this.service
                        .getTitulosAVencer(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-titulos-por-data':
                    this.service
                        .getTitulosPorData(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-clientes-por-atividade':
                    this.service
                        .getClientesPorAtividade(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-clientes-por-status-comercial':
                    this.service
                        .getClientesPorStatusComercial(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-cliente-com-vendas':
                    this.service
                        .saveClientesComVendas(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-vendas-por-periodo':
                    this.service
                        .saveVendasPorPeriodo(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-rotas-cadastradas':
                    this.service
                        .saveRotasCadastradas(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-cliente-sem-vendas-por-vendedor':
                    this.service
                        .saveClientesSemVendasPorVendedor(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-cliente-por-vendedor':
                    this.service
                        .saveClientesPorVendedor(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-cliente-por-faturamento-abc':
                    this.service
                        .saveClientesPorFaturamento(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-clientes-novos':
                    this.service
                        .saveClientesNovos(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-motivonaovenda':
                    this.service
                        .getMotivoNaoVenda(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-clientes-regiao':
                    this.service
                        .getClientesPorRegiao(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-clientes-nao-rota':
                    this.service
                        .getClientesEmNaoRota(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-nao-vendas':
                    this.service
                        .saveNaoVenda(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-valor-vendido-por-similar-agreagado':
                    this.service
                        .saveValorSimilarAgregado(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-qtd-produtos':
                    this.service
                        .getQtdProdutos(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-evolucao-vendas':
                    let data = { titulo: c.nome, tipo: 'evolucao-vendas' };
                    this.chartDataset.push(data);
                    this.showCharts = true;
                    c.isSaving = false;
                    setTimeout(() => {
                        this.carregarCartoes();
                    }, 5000);
                    break;
                case 'chart-visitas-colaborador-vendas':
                    this.service
                        .getVisitaColaborador(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-visitas-empresa-vendas':
                    this.service
                        .getVisitasEmpresa(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-colaborador-visita-periodo-do-dia-vendas':
                    this.service
                        .getColaboradorVisitaPeriodoDia(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-clientes-atendimentos':
                    this.service
                        .getClientesAtendimentos(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-venda-atendimentos':
                    this.service
                        .getVendaAtendimentos(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
                case 'chart-cliente-cidade':
                    this.service
                        .getClientePorCidade(this.filtros)
                        .then(this.pushIntoDataset)
                        .finally((_) => {
                            c.isSaving = false;
                        });
                    break;
            }
        },
        saveFiltros() {
            let erroFiltro = false;
            // Salva a posição dos filtros após a aplicar ou limpar
            if (this.vendedoresInner.length > 0) {
                this.filtros.vendedores = this.vendedoresInner.map((e) => Number(e.idusuario));
            } else {
                this.filtros.vendedores = [];
            }
            if (this.tipoPedidoSelected.length > 0) {
                this.filtros.tiposPedido = this.tipoPedidoSelected.map((e) => Number(e.id));
            } else {
                this.filtros.tiposPedido = [];
            }
            if (this.empresasInner.length > 0) {
                this.filtros.empresas = this.empresasInner.map((e) => Number(e.idempresa));
            } else {
                this.filtros.empresas = this.empresas.map((e) => Number(e.idempresa));
            }
            this.filtros.filtraEmpresa = this.empresasInner.length > 0;
            this.filtros.datainicio = this.datainicio;
            this.filtros.datafim = this.datafim;

            /**
             * @70409 - Verificando se as datas estão vazias.
             */
            if (this.filtros.datainicio == null) {
                this.erroDataInicio = true;
                erroFiltro = true;
            } else {
                this.erroDataInicio = false;
            }

            if (this.filtros.datafim == null) {
                this.erroDataFim = true;
                erroFiltro = true;
            } else {
                this.erroDataFim = false;
            }

            if (erroFiltro) {
                this.$root.showMessage('alert', 'datas-obrigatorias');
                return;
            }

            this.isSavingFilter = true;
            this.filtroList = this.getFiltroList();
            this.filtroCockpitService
                .save(this.filtroList, 'vendas')
                .then((r) => {
                    this.reloadCharts();
                    if (this.vendedoresInner.length > 0) {
                        this.vendedoresResultadoAtual = [...this.vendedoresInner];
                    } else {
                        this.vendedoresResultadoAtual = [...this.vendedores];
                    }
                })
                .catch((e) => {
                    console.error('Erro ao salvar filtros.', e);
                    this.$root.showMessage('error', 'msg-erro-filtros');
                })
                .finally((_) => {
                    this.isSavingFilter = false;
                });
        },
        reloadCharts() {
            // Após salvar os filtros os charts são recarregados
            this.fvwChartList
                .filter((e) => e.tipo != 'evolucao-vendas')
                .forEach((c) => {
                    let component = this.$refs[`${c.tipo}-${c.titulo}`][0];
                    /* Não são todos os charts que tem o cleanChart() */
                    if (component) {
                        if (component.cleanChart) {
                            component.cleanChart();
                        }
                        component.loadData();
                    }
                });
        },
        pushIntoDataset(data) {
            this.fvwChartList.push(data);
            this.chartDataset.push(data);
            this.showCharts = this.chartDataset.length > 0;
            setTimeout(() => {
                if (this.fvwChartList.length > 1) {
                    let el = this.$refs[`${data.tipo}-${data.titulo}`][0].$el.parentElement;
                    this.newCharts.push(el);
                    this.pckr.appended(el);
                    this.addNewChartPosition();
                    setTimeout(() => {
                        this.redrawCharts();
                    }, 50);
                } else {
                    this.mountCockpitCharts();
                }

                // Salva posição dos gráficos toda vez que um novo é adicionado.
                this.saveChartPositions();
                // this.carregarCartoes();
                this.mapToSaveChart();
            }, 50);
        },
        openModalGraficos() {
            // Usado dentro de gerenciar gŕaficos
            this.resultSet = this.chartsAvailable;
            this.getCategories();
            this.isChartSelectOpen = true;
        },
        getChartDesc(c) {
            // Usado dentro de gerenciar gŕaficos
            if (c.descricao != null || c.descricao != undefined) {
                return this.$t(c.descricao) ? this.$t(c.descricao) : this.$t('chart-no-desc');
            } else {
                console.warn('Descrição inexistente para ' + c.nome);
                return this.$t('chart-no-desc');
            }
        },
        addNewChartPosition() {
            if (this.pckr != null) {
                let positions = undefined;
                positions = this.pckr.getShiftPositions('data-item-id');
                if (this.curScreenSize > 1200) {
                    if (this.layout.grande) {
                        this.layout.grande.datacontent = positions;
                        this.layout.grande.tipo = 'vendas';
                    } else {
                        this.layout.grande = { datacontent: positions, tipo: 'vendas' };
                    }
                } else if (this.curScreenSize < 760) {
                    if (this.layout.pequeno) {
                        this.layout.pequeno.datacontent = positions;
                        this.layout.pequeno.tipo = 'vendas';
                    } else {
                        this.layout.pequeno = { datacontent: positions, tipo: 'vendas' };
                    }
                } else {
                    if (this.layout.medio) {
                        this.layout.medio.datacontent = positions;
                        this.layout.medio.tipo = 'vendas';
                    } else {
                        this.layout.medio = { datacontent: positions, tipo: 'vendas' };
                    }
                }
            }
        },
        saveChartPositions() {
            // get JSON-friendly data for items positions
            Packery.prototype.getShiftPositions = function (attrName) {
                attrName = attrName || 'id';
                let _this = this;
                return this.items.map(function (item) {
                    return {
                        attr: item.element.getAttribute(attrName),
                        x: item.rect.x / _this.packer.width,
                    };
                });
            };
            Packery.prototype.initShiftLayout = function (positions, attr) {
                let _this = this;
                if (!positions) {
                    // if no initial positions, run packery layout
                    _this.layout();
                    return;
                }
                // parse string to JSON
                if (typeof positions == 'string') {
                    try {
                        positions = JSON.parse(positions);
                    } catch (error) {
                        console.error('JSON parse error:', error, positions);
                        _this.layout();
                        return;
                    }
                }
                attr = attr || 'id'; // default to id attribute
                _this._resetLayout();
                // set item order and horizontal position from saved positions
                _this.items = positions.map(function (itemPosition) {
                    var selector = '[' + attr + '="' + itemPosition.attr + '"]';
                    var itemElem = _this.element.querySelector(selector);
                    var item = _this.getItem(itemElem);
                    item.rect.x = itemPosition.x * _this.packer.width;
                    return item;
                }, _this);
                _this.shiftLayout();
            };
            Packery.Item.prototype.setPosition = function (x, y) {
                if (x > 0) {
                    this.position.x = parseFloat(x) - 0.07;
                } else {
                    this.position.x = parseFloat(x);
                }
                this.position.y = parseFloat(y);
            };
        },
        bindDraggables(elem) {
            this.jqi(elem).on('dragstart', this.pckr.handleUIDraggable.start);
            this.jqi(elem).on('dragstart', this.closeAllFilters);
            this.jqi(elem).on('drag', this.pckr.handleUIDraggable.drag);
            this.jqi(elem).on('dragstop', this.pckr.handleUIDraggable.stop);
        },
        /*  Esta função serve para poder atualizar o conteúdo do card aqui
            ao invés de alterar a prop dentro do componente dele. */
        updateChart(datacontent, index) {
            this.$set(this.chartDataset, index, datacontent);
        },
        handleDateChange(nova_data, campo) {
            switch (campo) {
                case 'inicio':
                    this.filtros.datainicio = this.$moment(nova_data).format('YYYY-MM-DD');
                    break;
                case 'fim':
                    this.filtros.datafim = this.$moment(nova_data).format('YYYY-MM-DD');
                    break;
            }
        },
        /**
         * @84670 - validar se irá exibir tooltip de informação no cockpit
         */
        showInfo(tituloCockpit) {
            const chart = this.chartsAvailable.find((c) => c.nome === tituloCockpit);
            return chart && chart.descricao ? this.$t(chart.descricao) : null;
        },
        lineChartClas(d) {
            return (
                d &&
                (d.tipo == 'line' || d.tipo == 'bar' || d.tipo == 'zoombar') &&
                d.titulo != 'chart-cliente-cidade'
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.z-index-1 {
    z-index: 1;
}

#main {
    padding: 0 15px 15px 21px;
    height: auto;

    &.no-charts {
        height: 100%;
    }
}

img {
    width: 240px;
    height: 360px;
}

.page {
    position: relative;
    padding-left: 0;
    background: none;
    box-shadow: none;
}

.hero.is-fullheight {
    min-height: calc(100% - 20px);
}

.chart-toolbar .column .card {
    overflow: initial;
}

.footer {
    position: relative;
    bottom: 20px;
    width: 100%;
    /* top: calc(100% - 450px); */
    max-height: 300px;
    display: flex;
    justify-content: space-between;
}

.cockpit {
    position: relative;
    width: 100%;
    margin-bottom: 120px;
}

.cockpit .center p {
    height: 100%;
    margin-bottom: 40px;
    font-size: 20px;
    color: $text-color;
    width: 50%;
    left: 50%;
    position: relative;
    transform: translateX(-50%);
}

.cockpit .center .btn {
    color: $sovis-white;
    padding: 10px 70px;
}

.cockpit .center .elipse {
    margin-bottom: 40px;
    > .big-svg-icons {
        width: 250px;
        height: 125px;
        margin-top: -10px;
    }
}
.no-charts .center {
    top: 50%;
    transform: translate(-50%, -50%);

    .elipse {
        margin-bottom: 20px;
    }
    .big-svg-icons {
        top: 45%;
    }
}

// Modal adicionar gráfico ao cockpit
.modal-card-body .subtitle {
    margin-bottom: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 16px;
    color: $primary-color;
}

.manage-charts-link {
    font-size: 14px;
}

.manage-charts-shortcut {
    width: 100%;
    padding: 0 15px 10px 15px;
    display: flex;
    justify-content: flex-end;
}

.tag {
    background-color: $primary-color;
    color: $sovis-white;
}

.categorias {
    @media only screen and (max-width: 500px) {
        display: none !important;
    }

    .column {
        padding: 0.25rem 0.75rem;
        font-size: 14px;
    }
}

.result-set {
    padding: 0.25rem 0.75rem;
    height: calc(100vh - 190px);
    overflow: auto;
}

.no-results {
    height: calc(100vh - 190px);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: $text-color;
}

.add-btn,
.delete-btn {
    @media only screen and (max-width: 500px) {
        width: 100%;
    }

    display: flex;
    align-items: center;
    justify-content: center;
    color: $sovis-white;
    font-size: 12px;
    width: 250px;
    height: 35px;
    text-align: center;
    margin-left: 0px;
    padding: 10px;
    border: none;
    border-radius: 6px;
    @include gradient-button();
}

.delete-btn {
    @include exclude-button-2();
}

.chart-container {
    .chart {
        width: 32%;
        height: auto;
        min-height: 375px !important;

        &.big-number {
            height: 182px !important;
            min-height: unset !important;
        }

        &.speedometer {
            min-height: unset;
        }

        &.line-chart {
            width: 65%;
        }

        &.full-size-chart {
            width: 100% !important;
        }
    }
    .pkry-sizer {
        width: 32%;
    }
    .pkry-gutter {
        width: 1%;
    }
}

.chart-toolbar {
    position: sticky;
    top: 0;
    background: $bg-color; /* Precisa pq se não os elementos vão passar por cima do sticky por ser transparente. */
    /* Se for aumentar esse z-index, verificar dois possíveis pontos de falha
        - O modal do botão "Gerenciar gráficos"
        - O modal do botão de usuário no canto superior direito que ativa quando no modo mobile
    */

    .top-btn {
        height: 36px;
        margin-right: 10px !important;
    }

    .card {
        color: $darker-gray-color;

        .card-header-title {
            color: $darker-gray-color;
            justify-content: space-between;
            padding: 0.3rem;
        }

        .card-content {
            padding: 0.9rem;

            .card-content-top {
                padding-top: 0.25rem;
                padding-bottom: 0.25rem;
            }
        }
    }

    .filtro-header {
        display: flex;
        align-items: center;
    }

    .filtros-extras {
        font-size: 12px;
    }
}

@media only screen and (max-width: 1200px) {
    .chart-container {
        .chart {
            width: 49% !important;
            height: auto !important;
            min-height: 375px !important;

            &.big-number {
                height: 182px !important;
                min-height: unset !important;
            }

            &.speedometer {
                min-height: unset !important;
            }

            &.line-chart {
                width: 99% !important;
            }
        }

        .pkry-sizer {
            width: 49%;
        }
    }
}

@media only screen and (max-width: 860px) {
    .footer {
        display: none;
    }

    .chart-container {
        .chart {
            width: 49% !important;
            height: auto !important;
            min-height: 375px !important;

            &.big-number {
                height: 182px !important;
                min-height: unset !important;
            }

            &.speedometer {
                min-height: unset !important;
            }

            &.line-chart {
                width: 99% !important;
            }
        }

        .pkry-sizer {
            width: 49%;
        }
    }
}

@media only screen and (max-width: 760px) {
    .footer {
        display: none;
    }

    .chart-container {
        .chart {
            width: 100% !important;
            height: auto !important;
            min-height: 375px !important;

            &.big-number {
                min-height: unset !important;
            }

            &.speedometer {
                height: 300px;
            }

            &.line-chart {
                width: 100% !important;
            }
        }
        .pkry-sizer {
            width: 100%;
        }
    }

    .result-set {
        height: calc(100vh - 305px);
    }
}

.disabled {
    opacity: 0.4;
}
</style>
